// CMS entries for dfsweb-rewamp-help-support override these at runtime.
export const en = {
  "HELP_SUPPORT.TITLE": "Help & Support",
  "HELP_SUPPORT.CARD_GRIEVANCE_TITLE": "Grievance",
  "HELP_SUPPORT.CARD_GRIEVANCE_DESC": "Report issues related to schemes, payments, or services and track their status easily",
  "HELP_SUPPORT.CARD_GRIEVANCE_CTA": "Raise a Grievance",
  "HELP_SUPPORT.CARD_TECH_TITLE": "Technical Support",
  "HELP_SUPPORT.CARD_TECH_DESC": "Facing app or login problems? Get assistance to resolve technical issues quickly",
  "HELP_SUPPORT.CARD_TECH_CTA": "Raise an Issue",
  "HELP_SUPPORT.CALL_CENTRE_TITLE": "Call Centre",
  "HELP_SUPPORT.CALL_CENTRE_TIMINGS": "Support Hours: {{timings}} (except public holidays)",
  "CALL_CENTRE_HEADING.KISAN_CALL_CENTRE": "Kisan Call Centre",
  "CALL_CENTRE_HEADING.DBT_PM_KISAN_CALL_CENTRE": "DBT/PM-Kisan Call Centre",
  "CALL_CENTRE_HEADING.KISAN_HELP_LINE": "Kisan Help Line",
  "CALL_CENTRE_DAYS.MON_FRI": "Mon - Fri",
  "HELP_SUPPORT.DIRECTORY_TITLE": "Official Directory",
  "HELP_SUPPORT.COPY_NUMBER": "Copy number",
  "HELP_SUPPORT.NUMBER_COPIED": "Number copied",
  "HELP_SUPPORT.NO_CALL_CENTRES": "Call centre details are not available right now.",
  "HELP_SUPPORT.RETRY": "Retry",
  "HELP_SUPPORT.NO_DIRECTORIES": "Official directory details are not available right now.",
  "HELP_DETAILS.FIELD_DESIGNATION": "Designation",
  "HELP_DETAILS.FIELD_DISTRICT": "District",
  "HELP_DETAILS.FIELD_BLOCK": "Block",
  "HELP_DETAILS.FIELD_PANCHAYAT": "Panchayat",
  "HELP_DETAILS.FIELD_ADDRESS": "Address",
  "HELP_DETAILS.FIELD_EMAIL": "Email",
  "HELP_DETAILS.NO_DATA": "No data found. Please check back later or refine your search",
  "HELP_DETAILS.NO_RESULTS_TITLE": "No Results Found",
  "HELP_DETAILS.NO_RESULTS_DESC": "Filters applied do not have any result, try refining your search.",
  "HELP_DETAILS.VISIT_LINK": "Open link",
  "HELP_DETAILS.TABS_LABEL": "Departments",
  "GRM_STATUS.IN_PROGRESS": "In Progress",
  "GRM_STATUS.PENDING": "Pending",
  "GRM_STATUS.RESOLVED": "Resolved",
  "GRM_RAISE.TITLE": "Register New Grievance",
  "GRM_RAISE.DBT_REQUIRED_TITLE": "To raise a grievance kindly register with DBT",
  "GRM_RAISE.BREADCRUMB": "Register New Grievance",
  "GRM_RAISE.SECTION": "GRM Application",
  "GRM_RAISE.CATEGORY": "Service",
  "GRM_RAISE.SUB_CATEGORY": "Category",
  "GRM_RAISE.SUB_SUB_CATEGORY": "Sub Category",
  "GRM_RAISE.CATEGORY_PLACEHOLDER": "Select service",
  "GRM_RAISE.SUB_CATEGORY_PLACEHOLDER": "Select category",
  "GRM_RAISE.SUB_SUB_CATEGORY_PLACEHOLDER": "Select sub category",
  "GRM_RAISE.ADD_MORE": "Add more",
  "GRM_FORM.DESCRIPTION": "Description",
  "GRM_FORM.DESCRIPTION_PLACEHOLDER": "Enter Description",
  "GRM_FORM.DESCRIPTION_COUNTER": "{{count}}/{{max}} Characters",
  "GRM_FORM.ATTACH": "Attach Files",
  "GRM_FORM.FILE_TYPES": "Accepted: PDF, JPG, PNG, ZIP | Max. {{size}} MB/file | Up to {{max}} documents",
  "GRM_FORM.FILE_ERROR_SIZE": "Invalid Image uploaded : The file size exceeds the 10 MB limit.",
  "GRM_FORM.FILE_VALID": "Valid file uploaded",
  "GRM_FORM.REPLACE": "Replace",
  "GRM_FORM.CANCEL": "Cancel",
  "GRM_FORM.SUBMIT": "Save & Continue",
  "GRM_RAISE.ERROR_CATEGORY": "Please select a service.",
  "GRM_RAISE.ERROR_REQUIRED": "This field is required.",
  "GRM_RAISE.ERROR_TOO_LONG": "Description can be at most 1000 characters.",
  "GRM_RAISE.VOICE_START": "Speak to type",
  "GRM_RAISE.VOICE_STOP": "Stop Recording",
  "GRM_RAISE.VOICE_RESET": "Record again",
  "GRM_RAISE.VOICE_SECONDS": "seconds",
  "GRM_RAISE.VOICE_ANALYZING": "Please wait while we analyze your voice",
  "GRM_RAISE.VOICE_SUCCESS": "Speech inputted in the description",
  "GRM_RAISE.VOICE_NO_SPEECH": "Failed to detect speech",
  "GRM_RAISE.VOICE_FAILED": "Failed to analyze your voice",
  "GRM_RAISE.VOICE_PERMISSION": "Microphone access is blocked. Allow it from the site settings (lock icon in the address bar) and try again.",
  "GRM_RAISE.VOICE_NO_DEVICE": "No microphone found. Connect a microphone and try again.",
  "GRM_RAISE.VOICE_BUSY": "The microphone is being used by another app. Close it and try again.",
  "GRM_RAISE.SUBMIT_ERROR": "Your grievance could not be registered. Please try again.",
  "GRM_RAISE.CREATE_PGR_ERROR": "Your grievance could not be registered right now. Please request a new OTP and try again.",
  "GRM_RAISE.LOADING": "Loading grievance categories",
  "GRM_RAISE.LOAD_ERROR": "Grievance categories could not be loaded.",
  "GRM_RAISE.SUCCESS_TITLE": "GRM Submitted Successfully",
  "GRM_RAISE.SUCCESS_BODY": "Your GRM Application has been submitted.",
  "GRM_RAISE.TICKET_REFERENCE": "ID: {{id}}",
  "GRM_RAISE.APPLIED_ON": "Applied On : {{date}}",
  "GRM_RAISE.DOWNLOAD": "Download",
  "GRM_RAISE.HELPLINE_LABEL": "Bihar Krishi contact",
  "GRM_RAISE.HELPLINE_COPY": "Copy number",
  "GRM_RAISE.HELPLINE_COPIED": "Number copied",
  "GRM_RAISE.VIEW_TICKET": "View ticket",
  "GRM_RAISE.OKAY": "Okay",
  "GRM_RAISE.OTP_TITLE": "Farmer OTP Verification",
  "GRM_RAISE.ERROR_INCORRECT_OTP": "Incorrect OTP. Please check the OTP and try again.",
  "GRM_RAISE.ERROR_OTP_LIMIT": "Too many OTP requests. Please try again after some time.",
  "GRM_RAISE.ERROR_OTP_SEND": "The OTP could not be sent. Please try again.",
  "GRM_RAISE.ERROR_FARMER_DETAILS": "The farmer's mobile number or DBT ID is missing or does not match. Verify the farmer again and retry.",
  "GRM_RAISE.ERROR_FARMER_NOT_FOUND": "No farmer record was found for these details.",
  "GRM_RAISE.ERROR_NON_DBT": "This farmer is not registered with DBT, so this request cannot be raised for them.",
  "GRM_RAISE.ERROR_INVALID_CATEGORY": "The selected category is not available. Choose the category again and retry.",
  "GRM_TICKET.TICKET_LABEL": "Ticket",
  "GRM_TICKET.COPY_TICKET": "Copy ticket number",
  "GRM_TICKET.TICKET_COPIED": "Ticket number copied",
  "GRM_TICKET.APPLIED_ON": "Applied on",
  "GRM_TICKET.CATEGORY": "Service",
  "GRM_TICKET.SUB_CATEGORY": "Category",
  "GRM_TICKET.SUB_SUB_CATEGORY": "Sub Category",
  "GRM_TICKET.TRACK_TITLE": "Track Status",
  "GRM_TICKET.STAGE_APPLY": "Ticket Creation",
  "GRM_TICKET.STAGE_ASSIGN": "Grievance Assigned to {{officer}}",
  "GRM_TICKET.STAGE_RESOLVE": "Resolution by {{officer}}",
  "GRM_TICKET.STAGE_RESOLVE_KCC": "Resolved by Kisan Call Centre",
  "GRM_TICKET.STAGE_REOPEN": "Reopened by You",
  "GRM_TICKET.STAGE_CLOSE": "Closed",
  "GRM_TICKET.STAGE_VERIFY": "Verified by {{officer}}",
  "GRM_TICKET.LEVEL_L1": "Level 1 officer",
  "GRM_TICKET.LEVEL_L2": "Level 2 officer",
  "GRM_TICKET.LEVEL_L3": "Level 3 officer",
  "GRM_TICKET.LEVEL_L4": "Level 4 officer",
  "GRM_TICKET.LEVEL_JD": "Joint Director",
  "GRM_TICKET.LEVEL_SAO": "Sub-divisional Agriculture Officer",
  "GRM_TICKET.LEVEL_DEFAULT": "an officer",
  "GRM_TICKET.COMMENT": "Comment",
  "GRM_TICKET.ATTACHMENT_NAME": "Attachment {{index}}",
  "GRM_TICKET.VIEW_ATTACHMENT": "View",
  "GRM_TICKET.CLOSE_PREVIEW": "Close preview",
  "GRM_TICKET.PREVIEW_ERROR": "This file couldn't be loaded.",
  "GRM_TICKET.PREVIEW_LOADING": "Loading file",
  "GRM_TICKET.CURRENT_STAGE_TITLE": "Current Stage",
  "GRM_TICKET.STATUS": "Status",
  "GRM_TICKET.OFFICER": "Officer",
  "GRM_TICKET.OFFICER_CONTACT": "Officer contact",
  "GRM_TICKET.OFFICER_LOCATION": "Location",
  "GRM_TICKET.UNASSIGNED": "Your grievance is waiting to be assigned to an officer.",
  "GRM_TICKET.NOT_FOUND": "We couldn't find this grievance.",
  "GRM_TICKET.PAGE_TITLE": "{{status}} Grievance",
  "GRM_TICKET.ERROR": "Grievance details could not be loaded.",
  "GRM_TICKET.LOADING": "Loading grievance details",
  "GRM_TICKET.DOWNLOAD": "Download Grievance Ticket",
  "GRM_TICKET.PERSONAL_DETAILS": "Personal Details",
  "GRM_TICKET.DBT_NUMBER": "DBT Number",
  "GRM_TICKET.AADHAAR_NUMBER": "Aadhaar Number",
  "GRM_TICKET.AADHAAR_NAME": "Name as on Aadhaar",
  "GRM_TICKET.FATHER_HUSBAND_NAME": "Father's / Husband's Name",
  "GRM_TICKET.DOB": "Date of Birth",
  "GRM_TICKET.GENDER": "Gender",
  "GRM_TICKET.MOBILE_NUMBER": "Mobile Number",
  "GRM_TICKET.CASTE_CATEGORY": "Caste Category",
  "GRM_TICKET.FARMER_TYPE": "Type of Farmer",
  "GRM_TICKET.CATEGORY_TITLE": "Category",
  "GRM_TICKET.DESCRIPTION_TITLE": "Description",
  "GRM_TICKET.DESCRIPTION_LABEL": "Description",
  "GRM_LIST.TITLE": "Grievance",
  "GRM_LIST.BREADCRUMB": "Grievance",
  "GRM_LIST.CTA_REGISTER": "Register New Grievance",
  "GRM_LIST.TABS_LABEL": "Grievance tickets by status",
  "GRM_LIST.TAB_ALL": "All Tickets",
  "GRM_LIST.TAB_PENDING": "Pending Tickets",
  "GRM_LIST.TAB_RESOLVED": "Resolved Tickets",
  "GRM_LIST.FILTER_ARIA": "Filter grievance tickets",
  "GRM_LIST.FILTER_CATEGORY": "Service",
  "GRM_LIST.FILTER_SUB_CATEGORY": "Category",
  "GRM_LIST.FILTER_SUB_SUB_CATEGORY": "Sub Category",
  "GRM_LIST.FILTER_DATE": "Date",
  "GRM_LIST.TABLE_LABEL": "Your grievance tickets",
  "GRM_LIST.COL_TICKET": "Ticket Number",
  "GRM_LIST.COL_RAISED_ON": "Raised Date",
  "GRM_LIST.COL_STATUS": "Current Status",
  "GRM_LIST.COL_CATEGORY": "Service",
  "GRM_LIST.COL_SUB_CATEGORY": "Category",
  "GRM_LIST.COL_SUB_SUB_CATEGORY": "Sub Category",
  "GRM_LIST.COL_ACTION": "Action",
  "GRM_LIST.ACTION_DOWNLOAD": "Download",
  "GRM_LIST.ACTION_DOWNLOAD_ARIA": "Download ticket {{ticketId}}",
  "GRM_LIST.ACTION_VIEW": "View Ticket",
  "GRM_LIST.ACTION_VIEW_ARIA": "View ticket {{ticketId}}",
  "GRM_LIST.EMPTY_TITLE": "No Request Found",
  "GRM_LIST.EMPTY_CTA": "Register New Grievance",
  "GRM_LIST.EMPTY_FILTERED": "No grievances match the selected filters.",
  "GRM_LIST.ERROR": "Your grievances could not be loaded.",
  "GRM_LIST.LOADING": "Loading your grievances",
  "FAQ_PAGE.TITLE": "FAQs",
  "FAQ_PAGE.SEARCH_PLACEHOLDER": "Search",
  "FAQ_PAGE.SEARCH_RESULTS": "FAQ search results",
  "FAQ_PAGE.TABS_LABEL": "FAQ categories",
  "FAQ_PAGE.TAB_ALL": "All",
  "FAQ_PAGE.NO_RESULTS_TITLE": "No result found!",
  "FAQ_PAGE.NO_RESULTS_DESC": "If FAQs don't answer your queries, contact our call center.",
  "FAQ_PAGE.ERROR": "FAQs could not be loaded.",
  "FAQ_DETAIL.NOT_FOUND": "This FAQ is no longer available.",
  "TECH_LIST.TITLE": "Technical Support",
  "TECH_LIST.BREADCRUMB": "Technical Support",
  "TECH_LIST.CTA_REGISTER": "Register New Issue",
  "TECH_LIST.TABLE_LABEL": "Your technical issue tickets",
  "TECH_LIST.EMPTY_CTA": "Register new technical issues",
  "TECH_LIST.EMPTY_FILTERED": "No issues match the selected filters.",
  "TECH_LIST.ERROR": "Your issues could not be loaded.",
  "TECH_LIST.FILTER_CATEGORY": "Category",
  "TECH_LIST.FILTER_SUB_CATEGORY": "Sub Category",
  "TECH_LIST.COL_CATEGORY": "Category",
  "TECH_LIST.COL_SUB_CATEGORY": "Sub Category",
  "TECH_LIST.LOADING": "Loading your issues",
  "TECH_LIST.TABS_LABEL": "Technical issue tickets by status",
  "TECH_LIST.FILTER_ARIA": "Filter technical issue tickets",
  "TECH_RAISE.TITLE": "Technical Issue Registration",
  "TECH_RAISE.BREADCRUMB": "Register New Issue",
  "TECH_RAISE.SECTION": "Report Technical Issue",
  "TECH_RAISE.CATEGORY": "Category",
  "TECH_RAISE.SUB_CATEGORY": "Sub Category",
  "TECH_RAISE.CATEGORY_PLACEHOLDER": "Select category",
  "TECH_RAISE.SUB_CATEGORY_PLACEHOLDER": "Select sub category",
  "TECH_RAISE.ERROR_CATEGORY": "Please select a category.",
  "TECH_RAISE.SUBMIT_ERROR": "Your issue could not be registered. Please try again.",
  "TECH_RAISE.CREATE_PGR_ERROR": "Your issue could not be registered right now. Please request a new OTP and try again.",
  "TECH_RAISE.LOADING": "Loading issue categories",
  "TECH_RAISE.LOAD_ERROR": "Issue categories could not be loaded.",
  "TECH_RAISE.SUCCESS_TITLE": "Issue Raised Successfully",
  "TECH_RAISE.SUCCESS_BODY": "Your technical issue has been submitted. Our team will review it and get back to you shortly.",
  "TECH_RAISE.VIEW_TICKET": "View Ticket",
  "TECH_TICKET.NOT_FOUND": "We couldn't find this issue.",
  "TECH_TICKET.PAGE_TITLE": "{{status}} Technical Issue",
  "TECH_TICKET.CATEGORY": "Category",
  "TECH_TICKET.SUB_CATEGORY": "Sub Category",
  "TECH_TICKET.DOWNLOAD": "Download Ticket",
  "TECH_TICKET.NAME": "Name",
  "TECH_TICKET.LOADING": "Loading issue details",
  "TECH_TICKET.ERROR": "Issue details could not be loaded.",
  "TECH_TICKET.UNASSIGNED": "Your issue is waiting to be assigned to an officer.",
  "TECH_IDENTITY.LABEL": "Raise issue for",
  "TECH_IDENTITY.SELF": "Self",
  "TECH_IDENTITY.FARMER": "Farmer",
  "GRM_RATING.TITLE": "How would you rate this support?",
  "GRM_RATING.SUBTITLE": "Your rating helps us improve our support.",
  "GRM_RATING.STAR_LABEL": "{{count}} out of 5 stars",
  "GRM_RATING.ROW_LABEL": "Rating: {{count}} out of 5",
  "GRM_RATING.LATER": "Do it Later",
  "GRM_RATING.SUBMIT": "Submit Rating",
  "GRM_RATING.REQUIRED": "Please select a rating.",
  "GRM_RATING.RATE": "Rate Us",
  "GRM_RATING.RATE_ARIA": "Rate ticket {{ticketId}}",
  "GRM_RATING.ERROR": "Your rating could not be submitted. Please try again.",
  "GRM_RATING.SUCCESS_TITLE": "Thank you for your feedback",
  "GRM_RATING.SUCCESS_BODY": "Your rating has been submitted.",
  "GRM_RATING.CLOSE": "Close",
  "GRM_RATING.SECTION_TITLE": "Rate this experience",
  "GRM_RATING.RATED_TITLE": "Thank you for your feedback!",
  "GRM_RATING.RATED_VALUE": "You rated this support {{count}} out of 5",
  "GRM_REOPEN.CTA": "Reopen Ticket",
  "GRM_REOPEN.CONFIRM_TITLE": "Reopening of Ticket",
  "GRM_REOPEN.CONFIRM_QUESTION": "Are you sure you want to reopen the ticket?",
  "GRM_REOPEN.CONFIRM_ID": "ID : {{ticketId}}",
  "GRM_REOPEN.CANCEL": "No, Cancel",
  "GRM_REOPEN.CONTINUE": "Continue",
  "GRM_REOPEN.SECTION": "Reopening of Ticket",
  "GRM_REOPEN.PROCEED_WITH_OTP": "Proceed with OTP",
  "GRM_REOPEN.VERIFY_SUBMIT": "Verify & Submit",
  "GRM_REOPEN.SUBMIT_ERROR": "The ticket could not be reopened. Please try again.",
  "GRM_REOPEN.SUCCESS_TITLE": "Grievance Reopened Successfully",
  "GRM_REOPEN.SUCCESS_BODY": "Ticket is reopened successfully and moved to pending ticket",
  "GRM_REOPEN.SUCCESS_ID": "ID: {{id}}",
  "GRM_REOPEN.REOPENED_ON": "Reopened On : {{date}}",
  "GRM_REOPEN.VIEW_TICKET": "View Ticket",
  "GRM_REOPEN.OKAY": "Okay",
};

export const hi = {
  "HELP_SUPPORT.TITLE": "सहायता एवं समर्थन",
  // Hindi for card copy is the APK dfs-helpSection wording
  "HELP_SUPPORT.CARD_GRIEVANCE_TITLE": "शिकायत",
  "HELP_SUPPORT.CARD_GRIEVANCE_DESC": "स्कीम, पेमेंट या सर्विस से जुड़ी समस्याओं की रिपोर्ट करें और आसानी से उनका स्टेटस ट्रैक करें।",
  "HELP_SUPPORT.CARD_GRIEVANCE_CTA": "शिकायत दर्ज करें",
  "HELP_SUPPORT.CARD_TECH_TITLE": "तकनीकी सहायता",
  "HELP_SUPPORT.CARD_TECH_DESC": "ऐप या लॉगिन समस्या? तकनीकी समस्याओं को जल्दी हल करने में सहायता प्राप्त करें",
  "HELP_SUPPORT.CARD_TECH_CTA": "समस्या दर्ज करें",
  "HELP_SUPPORT.CALL_CENTRE_TITLE": "कॉल सेंटर",
  "CALL_CENTRE_HEADING.KISAN_CALL_CENTRE": "किसान कॉल सेंटर",
  "CALL_CENTRE_HEADING.DBT_PM_KISAN_CALL_CENTRE": "डीबीटी/पीएम-किसान कॉल सेंटर",
  "CALL_CENTRE_HEADING.KISAN_HELP_LINE": "किसान हेल्प लाइन",
  "CALL_CENTRE_DAYS.MON_FRI": "सोम - शुक्र",
  // inferred, needs translator
  "HELP_SUPPORT.CALL_CENTRE_TIMINGS": "सहायता समय: {{timings}} (सार्वजनिक अवकाश को छोड़कर)",
  // inferred, needs translator
  "HELP_SUPPORT.DIRECTORY_TITLE": "आधिकारिक निर्देशिका",
  // inferred, needs translator
  "HELP_SUPPORT.COPY_NUMBER": "नंबर कॉपी करें",
  // inferred, needs translator
  "HELP_SUPPORT.NUMBER_COPIED": "नंबर कॉपी हो गया",
  // inferred, needs translator
  "HELP_SUPPORT.NO_CALL_CENTRES": "कॉल सेंटर की जानकारी अभी उपलब्ध नहीं है।",
  "HELP_SUPPORT.RETRY": "पुनः प्रयास करें",
  // inferred, needs translator
  "HELP_SUPPORT.NO_DIRECTORIES": "आधिकारिक निर्देशिका की जानकारी अभी उपलब्ध नहीं है।",
  // inferred, needs translator
  "HELP_DETAILS.FIELD_DESIGNATION": "पदनाम",
  "HELP_DETAILS.FIELD_DISTRICT": "जिला",
  "HELP_DETAILS.FIELD_BLOCK": "प्रखंड",
  "HELP_DETAILS.FIELD_PANCHAYAT": "पंचायत",
  // inferred, needs translator
  "HELP_DETAILS.FIELD_ADDRESS": "पता",
  // inferred, needs translator
  "HELP_DETAILS.FIELD_EMAIL": "ईमेल",
  // inferred, needs translator
  "HELP_DETAILS.NO_DATA": "कोई डेटा नहीं मिला। कृपया बाद में जांचें या अपनी खोज बदलें",
  // inferred, needs translator
  "HELP_DETAILS.NO_RESULTS_TITLE": "कोई परिणाम नहीं मिला",
  // inferred, needs translator
  "HELP_DETAILS.NO_RESULTS_DESC": "लागू किए गए फ़िल्टर का कोई परिणाम नहीं है, अपनी खोज बदलकर देखें।",
  // inferred, needs translator
  "HELP_DETAILS.VISIT_LINK": "लिंक खोलें",
  // inferred, needs translator
  "HELP_DETAILS.TABS_LABEL": "विभाग",
  "GRM_STATUS.IN_PROGRESS": "प्रगति पर है",
  "GRM_STATUS.PENDING": "लंबित",
  "GRM_STATUS.RESOLVED": "समाधानित",
  "GRM_RAISE.TITLE": "नई शिकायत दर्ज करें",
  // inferred, needs translator
  "GRM_RAISE.DBT_REQUIRED_TITLE": "शिकायत दर्ज करने के लिए कृपया डीबीटी पर पंजीकरण करें",
  // inferred, needs translator
  "GRM_RAISE.BREADCRUMB": "नई शिकायत दर्ज करें",
  "GRM_RAISE.SECTION": "जीआरएम आवेदन",
  "GRM_RAISE.CATEGORY": "सेवा",
  "GRM_RAISE.SUB_CATEGORY": "श्रेणी",
  "GRM_RAISE.SUB_SUB_CATEGORY": "उप श्रेणी",
  // inferred, needs translator
  "GRM_RAISE.CATEGORY_PLACEHOLDER": "सेवा चुनें",
  "GRM_RAISE.SUB_CATEGORY_PLACEHOLDER": "श्रेणी चुनें",
  "GRM_RAISE.SUB_SUB_CATEGORY_PLACEHOLDER": "उप श्रेणी चुनें",
  // inferred, needs translator
  // inferred, needs translator
  // inferred, needs translator
  "GRM_RAISE.ADD_MORE": "और जोड़ें",
  // inferred, needs translator
  "GRM_FORM.DESCRIPTION": "विवरण",
  "GRM_FORM.DESCRIPTION_PLACEHOLDER": "विवरण दर्ज करें",
  "GRM_FORM.DESCRIPTION_COUNTER": "{{count}}/{{max}} अक्षर",
  "GRM_FORM.ATTACH": "फ़ाइलें संलग्न करें",
  "GRM_FORM.FILE_TYPES": "स्वीकृत: PDF, JPG, PNG, ZIP | अधिकतम {{size}} MB/फ़ाइल | अधिकतम {{max}} दस्तावेज़",
  // inferred, needs translator
  "GRM_FORM.FILE_ERROR_SIZE": "अपलोड की गई इमेज अमान्य है: फ़ाइल का आकार 10 MB की अधिकतम सीमा से अधिक है।",
  // inferred, needs translator
  "GRM_FORM.FILE_VALID": "मान्य फ़ाइल अपलोड हो गई",
  // inferred, needs translator
  "GRM_FORM.REPLACE": "बदलें",
  "GRM_FORM.CANCEL": "रद्द करें",
  "GRM_FORM.SUBMIT": "सहेजें और आगे बढ़ें",
  // inferred, needs translator
  "GRM_RAISE.ERROR_CATEGORY": "कृपया सेवा चुनें।",
  // inferred, needs translator
  "GRM_RAISE.ERROR_REQUIRED": "यह फ़ील्ड आवश्यक है।",
  // inferred, needs translator
  "GRM_RAISE.ERROR_TOO_LONG": "विवरण अधिकतम 1000 अक्षरों का हो सकता है।",
  "GRM_RAISE.VOICE_START": "बोलकर लिखें",
  "GRM_RAISE.VOICE_STOP": "रिकॉर्डिंग बंद करें",
  "GRM_RAISE.VOICE_RESET": "फिर से रिकॉर्ड करें",
  "GRM_RAISE.VOICE_SECONDS": "सेकंड",
  "GRM_RAISE.VOICE_ANALYZING": "कृपया प्रतीक्षा करें, हम आपकी आवाज़ का विश्लेषण कर रहे हैं।",
  "GRM_RAISE.VOICE_SUCCESS": "विवरण में आवाज़ दर्ज की गई",
  "GRM_RAISE.VOICE_NO_SPEECH": "आवाज़ का पता लगाने में विफल",
  "GRM_RAISE.VOICE_FAILED": "आपकी आवाज़ का विश्लेषण करने में विफल रहे।",
  "GRM_RAISE.VOICE_PERMISSION": "माइक्रोफ़ोन की अनुमति बंद है। साइट सेटिंग्स (एड्रेस बार में लॉक आइकन) से अनुमति दें और फिर से प्रयास करें।",
  "GRM_RAISE.VOICE_NO_DEVICE": "कोई माइक्रोफ़ोन नहीं मिला। माइक्रोफ़ोन जोड़ें और फिर से प्रयास करें।",
  "GRM_RAISE.VOICE_BUSY": "माइक्रोफ़ोन किसी अन्य ऐप द्वारा उपयोग में है। उसे बंद करके फिर से प्रयास करें।",
  // inferred, needs translator
  "GRM_RAISE.SUBMIT_ERROR": "आपकी शिकायत दर्ज नहीं हो सकी। कृपया पुनः प्रयास करें।",
  // inferred, needs translator
  "GRM_RAISE.CREATE_PGR_ERROR": "आपकी शिकायत अभी दर्ज नहीं हो सकी। कृपया नया ओटीपी लें और पुनः प्रयास करें।",
  // inferred, needs translator
  "GRM_RAISE.LOADING": "शिकायत श्रेणियाँ लोड हो रही हैं",
  // inferred, needs translator
  "GRM_RAISE.LOAD_ERROR": "शिकायत श्रेणियाँ लोड नहीं हो सकीं।",
  // inferred, needs translator
  "GRM_RAISE.SUCCESS_TITLE": "शिकायत सफलतापूर्वक जमा की गई",
  // inferred, needs translator
  "GRM_RAISE.SUCCESS_BODY": "आपका शिकायत आवेदन जमा कर दिया गया है।",
  // inferred, needs translator
  "GRM_RAISE.TICKET_REFERENCE": "आईडी: {{id}}",
  // inferred, needs translator
  "GRM_RAISE.APPLIED_ON": "आवेदन तिथि : {{date}}",
  // inferred, needs translator
  "GRM_RAISE.DOWNLOAD": "डाउनलोड करें",
  // inferred, needs translator
  "GRM_RAISE.HELPLINE_LABEL": "बिहार कृषि संपर्क",
  // inferred, needs translator
  "GRM_RAISE.HELPLINE_COPY": "नंबर कॉपी करें",
  // inferred, needs translator
  "GRM_RAISE.HELPLINE_COPIED": "नंबर कॉपी हो गया",
  // inferred, needs translator
  "GRM_RAISE.VIEW_TICKET": "टिकट देखें",
  // inferred, needs translator
  "GRM_RAISE.OKAY": "ठीक है",
  "GRM_RAISE.OTP_TITLE": "किसान ओटीपी सत्यापन",
  // inferred, needs translator
  "GRM_RAISE.ERROR_INCORRECT_OTP": "गलत ओटीपी। कृपया ओटीपी जाँचें और पुनः प्रयास करें।",
  // inferred, needs translator
  "GRM_RAISE.ERROR_OTP_LIMIT": "बहुत अधिक ओटीपी अनुरोध। कृपया कुछ समय बाद पुनः प्रयास करें।",
  // inferred, needs translator
  "GRM_RAISE.ERROR_OTP_SEND": "ओटीपी नहीं भेजा जा सका। कृपया पुनः प्रयास करें।",
  // inferred, needs translator
  "GRM_RAISE.ERROR_FARMER_DETAILS": "किसान का मोबाइल नंबर या डीबीटी आई.डी. उपलब्ध नहीं है या मेल नहीं खाता। किसान का पुनः सत्यापन करें और फिर प्रयास करें।",
  // inferred, needs translator
  "GRM_RAISE.ERROR_FARMER_NOT_FOUND": "इन विवरणों के लिए कोई किसान रिकॉर्ड नहीं मिला।",
  // inferred, needs translator
  "GRM_RAISE.ERROR_NON_DBT": "यह किसान डीबीटी में पंजीकृत नहीं है, इसलिए उनके लिए यह अनुरोध दर्ज नहीं किया जा सकता।",
  // inferred, needs translator
  "GRM_RAISE.ERROR_INVALID_CATEGORY": "चुनी गई श्रेणी उपलब्ध नहीं है। श्रेणी दोबारा चुनें और पुनः प्रयास करें।",
  "GRM_TICKET.TICKET_LABEL": "टिकट",
  // inferred, needs translator
  "GRM_TICKET.COPY_TICKET": "टिकट संख्या कॉपी करें",
  // inferred, needs translator
  "GRM_TICKET.TICKET_COPIED": "टिकट संख्या कॉपी हो गई",
  // inferred, needs translator
  "GRM_TICKET.APPLIED_ON": "आवेदन तिथि",
  "GRM_TICKET.CATEGORY": "सेवा",
  "GRM_TICKET.SUB_CATEGORY": "श्रेणी",
  "GRM_TICKET.SUB_SUB_CATEGORY": "उप श्रेणी",
  // inferred, needs translator
  "GRM_TICKET.TRACK_TITLE": "स्थिति ट्रैक करें",
  // inferred, needs translator
  "GRM_TICKET.STAGE_APPLY": "टिकट निर्गत",
  // inferred, needs translator
  "GRM_TICKET.STAGE_ASSIGN": "शिकायत {{officer}} को सौंपी गई",
  // inferred, needs translator
  "GRM_TICKET.STAGE_RESOLVE": "{{officer}} द्वारा समाधानित",
  // inferred, needs translator
  "GRM_TICKET.STAGE_RESOLVE_KCC": "किसान कॉल सेंटर द्वारा समाधान किया गया",
  // inferred, needs translator
  "GRM_TICKET.STAGE_REOPEN": "आपके द्वारा पुनः खोला गया",
  // inferred, needs translator
  "GRM_TICKET.STAGE_CLOSE": "बंद की गई",
  // inferred, needs translator
  "GRM_TICKET.STAGE_VERIFY": "{{officer}} द्वारा सत्यापित",
  // inferred, needs translator
  "GRM_TICKET.LEVEL_L1": "स्तर 1 अधिकारी",
  // inferred, needs translator
  "GRM_TICKET.LEVEL_L2": "स्तर 2 अधिकारी",
  // inferred, needs translator
  "GRM_TICKET.LEVEL_L3": "स्तर 3 अधिकारी",
  // inferred, needs translator
  "GRM_TICKET.LEVEL_L4": "स्तर 4 अधिकारी",
  // inferred, needs translator
  "GRM_TICKET.LEVEL_JD": "संयुक्त निदेशक",
  // inferred, needs translator
  "GRM_TICKET.LEVEL_SAO": "अनुमंडल कृषि पदाधिकारी",
  // inferred, needs translator
  "GRM_TICKET.LEVEL_DEFAULT": "एक अधिकारी",
  // inferred, needs translator
  "GRM_TICKET.COMMENT": "टिप्पणी",
  // inferred, needs translator
  "GRM_TICKET.ATTACHMENT_NAME": "संलग्नक {{index}}",
  // inferred, needs translator
  "GRM_TICKET.VIEW_ATTACHMENT": "देखें",
  // inferred, needs translator
  "GRM_TICKET.CLOSE_PREVIEW": "पूर्वावलोकन बंद करें",
  // inferred, needs translator
  "GRM_TICKET.PREVIEW_ERROR": "यह फ़ाइल लोड नहीं हो सकी।",
  // inferred, needs translator
  "GRM_TICKET.PREVIEW_LOADING": "फ़ाइल लोड हो रही है",
  // inferred, needs translator
  "GRM_TICKET.CURRENT_STAGE_TITLE": "वर्तमान चरण",
  "GRM_TICKET.STATUS": "स्थिति",
  "GRM_TICKET.OFFICER": "अधिकारी",
  // inferred, needs translator
  "GRM_TICKET.OFFICER_CONTACT": "अधिकारी संपर्क",
  // inferred, needs translator
  "GRM_TICKET.OFFICER_LOCATION": "स्थान",
  // inferred, needs translator
  "GRM_TICKET.UNASSIGNED": "आपकी शिकायत किसी अधिकारी को सौंपे जाने की प्रतीक्षा में है।",
  // inferred, needs translator
  "GRM_TICKET.NOT_FOUND": "यह शिकायत नहीं मिली।",
  // inferred, needs translator
  "GRM_TICKET.PAGE_TITLE": "{{status}} शिकायत",
  // inferred, needs translator
  "GRM_TICKET.ERROR": "शिकायत का विवरण लोड नहीं हो सका।",
  // inferred, needs translator
  "GRM_TICKET.LOADING": "शिकायत का विवरण लोड हो रहा है",
  "GRM_TICKET.DOWNLOAD": "शिकायत टिकट डाउनलोड करें",
  // inferred, needs translator
  "GRM_TICKET.PERSONAL_DETAILS": "व्यक्तिगत विवरण",
  // inferred, needs translator
  "GRM_TICKET.DBT_NUMBER": "डीबीटी संख्या",
  // inferred, needs translator
  "GRM_TICKET.AADHAAR_NUMBER": "आधार संख्या",
  // inferred, needs translator
  "GRM_TICKET.AADHAAR_NAME": "आधार के अनुसार नाम",
  // inferred, needs translator
  "GRM_TICKET.FATHER_HUSBAND_NAME": "पिता / पति का नाम",
  // inferred, needs translator
  "GRM_TICKET.DOB": "जन्म तिथि",
  // inferred, needs translator
  "GRM_TICKET.GENDER": "लिंग",
  // inferred, needs translator
  "GRM_TICKET.MOBILE_NUMBER": "मोबाइल नंबर",
  // inferred, needs translator
  "GRM_TICKET.CASTE_CATEGORY": "जाति श्रेणी",
  // inferred, needs translator
  "GRM_TICKET.FARMER_TYPE": "किसान का प्रकार",
  // inferred, needs translator
  "GRM_TICKET.CATEGORY_TITLE": "श्रेणी",
  // inferred, needs translator
  "GRM_TICKET.DESCRIPTION_TITLE": "विवरण",
  // inferred, needs translator
  "GRM_TICKET.DESCRIPTION_LABEL": "विवरण",
  "GRM_LIST.TITLE": "शिकायत",
  "GRM_LIST.BREADCRUMB": "शिकायत",
  // inferred, needs translator
  "GRM_LIST.CTA_REGISTER": "नई शिकायत दर्ज करें",
  // inferred, needs translator
  "GRM_LIST.TABS_LABEL": "स्थिति के अनुसार शिकायत टिकट",
  // inferred, needs translator
  "GRM_LIST.TAB_ALL": "सभी टिकट",
  // inferred, needs translator
  "GRM_LIST.TAB_PENDING": "लंबित टिकट",
  // inferred, needs translator
  "GRM_LIST.TAB_RESOLVED": "समाधान किए गए टिकट",
  // inferred, needs translator
  "GRM_LIST.FILTER_ARIA": "शिकायत टिकट फ़िल्टर करें",
  "GRM_LIST.FILTER_CATEGORY": "सेवा",
  "GRM_LIST.FILTER_SUB_CATEGORY": "श्रेणी",
  "GRM_LIST.FILTER_SUB_SUB_CATEGORY": "उप श्रेणी",
  "GRM_LIST.FILTER_DATE": "तिथि",
  // inferred, needs translator
  "GRM_LIST.TABLE_LABEL": "आपके शिकायत टिकट",
  // inferred, needs translator
  "GRM_LIST.COL_TICKET": "टिकट संख्या",
  // inferred, needs translator
  "GRM_LIST.COL_RAISED_ON": "दर्ज करने की तिथि",
  // inferred, needs translator
  "GRM_LIST.COL_STATUS": "वर्तमान स्थिति",
  "GRM_LIST.COL_CATEGORY": "सेवा",
  "GRM_LIST.COL_SUB_CATEGORY": "श्रेणी",
  "GRM_LIST.COL_SUB_SUB_CATEGORY": "उप श्रेणी",
  // inferred, needs translator
  "GRM_LIST.COL_ACTION": "कार्रवाई",
  // inferred, needs translator
  "GRM_LIST.ACTION_DOWNLOAD": "डाउनलोड करें",
  // inferred, needs translator
  "GRM_LIST.ACTION_DOWNLOAD_ARIA": "टिकट {{ticketId}} डाउनलोड करें",
  // inferred, needs translator
  "GRM_LIST.ACTION_VIEW": "टिकट देखें",
  // inferred, needs translator
  "GRM_LIST.ACTION_VIEW_ARIA": "टिकट {{ticketId}} देखें",
  // inferred, needs translator
  "GRM_LIST.EMPTY_TITLE": "कोई अनुरोध नहीं मिला",
  "GRM_LIST.EMPTY_CTA": "नई शिकायत दर्ज करें",
  // inferred, needs translator
  "GRM_LIST.EMPTY_FILTERED": "चयनित फ़िल्टर से कोई शिकायत मेल नहीं खाती।",
  // inferred, needs translator
  "GRM_LIST.ERROR": "आपकी शिकायतें लोड नहीं हो सकीं।",
  // inferred, needs translator
  "GRM_LIST.LOADING": "आपकी शिकायतें लोड हो रही हैं",
  // inferred, needs translator
  "FAQ_PAGE.TITLE": "अक्सर पूछे जाने वाले प्रश्न",
  "FAQ_PAGE.SEARCH_PLACEHOLDER": "खोजें",
  // inferred, needs translator
  "FAQ_PAGE.SEARCH_RESULTS": "प्रश्न खोज परिणाम",
  "FAQ_PAGE.TABS_LABEL": "प्रश्न श्रेणियाँ",
  "FAQ_PAGE.TAB_ALL": "सभी",
  "FAQ_PAGE.NO_RESULTS_TITLE": "कोई परिणाम नहीं मिला!",
  "FAQ_PAGE.NO_RESULTS_DESC": "यदि अक्सर पूछे जाने वाले प्रश्न आपकी जिज्ञासा का समाधान नहीं करते, तो हमारे कॉल सेंटर से संपर्क करें।",
  "FAQ_PAGE.ERROR": "प्रश्न लोड नहीं हो सके।",
  // inferred, needs translator
  "FAQ_DETAIL.NOT_FOUND": "यह प्रश्न अब उपलब्ध नहीं है।",
  "TECH_LIST.TITLE": "तकनीकी सहायता",
  "TECH_LIST.BREADCRUMB": "तकनीकी सहायता",
  "TECH_LIST.CTA_REGISTER": "नई समस्या दर्ज करें",
  "TECH_LIST.TABLE_LABEL": "आपके तकनीकी समस्या टिकट",
  "TECH_LIST.EMPTY_CTA": "नई तकनीकी समस्या दर्ज करें",
  "TECH_LIST.EMPTY_FILTERED": "चयनित फ़िल्टर से कोई समस्या मेल नहीं खाती।",
  "TECH_LIST.ERROR": "आपकी समस्याएँ लोड नहीं हो सकीं।",
  "TECH_LIST.FILTER_CATEGORY": "श्रेणी",
  "TECH_LIST.FILTER_SUB_CATEGORY": "उप श्रेणी",
  "TECH_LIST.COL_CATEGORY": "श्रेणी",
  "TECH_LIST.COL_SUB_CATEGORY": "उप श्रेणी",
  // inferred, needs translator
  "TECH_LIST.LOADING": "आपकी समस्याएँ लोड हो रही हैं",
  // inferred, needs translator
  "TECH_LIST.TABS_LABEL": "स्थिति के अनुसार तकनीकी समस्या टिकट",
  // inferred, needs translator
  "TECH_LIST.FILTER_ARIA": "तकनीकी समस्या टिकट फ़िल्टर करें",
  // inferred, needs translator
  "TECH_RAISE.TITLE": "तकनीकी समस्या पंजीकरण",
  "TECH_RAISE.BREADCRUMB": "नई समस्या दर्ज करें",
  // inferred, needs translator
  "TECH_RAISE.SECTION": "तकनीकी समस्या की रिपोर्ट करें",
  "TECH_RAISE.CATEGORY": "श्रेणी",
  "TECH_RAISE.SUB_CATEGORY": "उप श्रेणी",
  "TECH_RAISE.CATEGORY_PLACEHOLDER": "श्रेणी चुनें",
  "TECH_RAISE.SUB_CATEGORY_PLACEHOLDER": "उप श्रेणी चुनें",
  "TECH_RAISE.ERROR_CATEGORY": "कृपया श्रेणी चुनें।",
  "TECH_RAISE.SUBMIT_ERROR": "आपकी समस्या दर्ज नहीं हो सकी। कृपया पुनः प्रयास करें।",
  // inferred, needs translator
  "TECH_RAISE.CREATE_PGR_ERROR": "आपकी समस्या अभी दर्ज नहीं हो सकी। कृपया नया ओटीपी लें और पुनः प्रयास करें।",
  "TECH_RAISE.LOADING": "समस्या श्रेणियाँ लोड हो रही हैं",
  "TECH_RAISE.LOAD_ERROR": "समस्या श्रेणियाँ लोड नहीं हो सकीं।",
  "TECH_RAISE.SUCCESS_TITLE": "समस्या सफलतापूर्वक दर्ज की गई",
  "TECH_RAISE.SUCCESS_BODY": "आपकी तकनीकी समस्या जमा कर दी गई है। हमारी टीम इसकी समीक्षा करके शीघ्र ही आपसे संपर्क करेगी।",
  "TECH_RAISE.VIEW_TICKET": "टिकट देखें",
  "TECH_TICKET.NOT_FOUND": "यह समस्या नहीं मिली।",
  // inferred, needs translator
  "TECH_TICKET.PAGE_TITLE": "{{status}} तकनीकी समस्या",
  "TECH_TICKET.CATEGORY": "श्रेणी",
  "TECH_TICKET.SUB_CATEGORY": "उप श्रेणी",
  "TECH_TICKET.DOWNLOAD": "टिकट डाउनलोड करें",
  "TECH_TICKET.NAME": "नाम",
  // inferred, needs translator
  "TECH_TICKET.LOADING": "समस्या का विवरण लोड हो रहा है",
  // inferred, needs translator
  "TECH_TICKET.ERROR": "समस्या का विवरण लोड नहीं हो सका।",
  // inferred, needs translator
  "TECH_TICKET.UNASSIGNED": "आपकी समस्या किसी अधिकारी को सौंपे जाने की प्रतीक्षा में है।",
  // inferred, needs translator
  "TECH_IDENTITY.LABEL": "समस्या किसके लिए",
  "TECH_IDENTITY.SELF": "स्वयं",
  "TECH_IDENTITY.FARMER": "किसान",
  "GRM_RATING.TITLE": "आप इस सहायता को कैसी रेटिंग देंगे?",
  "GRM_RATING.SUBTITLE": "आपकी रेटिंग हमें अपनी सहायता बेहतर बनाने में मदद करती है।",
  "GRM_RATING.STAR_LABEL": "5 में से {{count}} स्टार",
  "GRM_RATING.ROW_LABEL": "रेटिंग: 5 में से {{count}}",
  "GRM_RATING.LATER": "इसे बाद में करें",
  "GRM_RATING.SUBMIT": "रेटिंग जमा करें",
  "GRM_RATING.REQUIRED": "कृपया रेटिंग चुनें।",
  "GRM_RATING.RATE": "हमें रेटिंग दें",
  "GRM_RATING.RATE_ARIA": "टिकट {{ticketId}} को रेटिंग दें",
  "GRM_RATING.ERROR": "आपकी रेटिंग जमा नहीं हो सकी। कृपया पुनः प्रयास करें।",
  "GRM_RATING.SUCCESS_TITLE": "आपकी प्रतिक्रिया के लिए धन्यवाद",
  "GRM_RATING.SUCCESS_BODY": "आपकी रेटिंग जमा हो गई है।",
  "GRM_RATING.CLOSE": "बंद करें",
  "GRM_RATING.SECTION_TITLE": "इस अनुभव को रेट करें",
  "GRM_RATING.RATED_TITLE": "आपकी प्रतिक्रिया के लिए धन्यवाद!",
  "GRM_RATING.RATED_VALUE": "आपने इस सहायता को 5 में से {{count}} रेटिंग दी",
  "GRM_REOPEN.CTA": "टिकट को पुनः खोलें",
  "GRM_REOPEN.CONFIRM_TITLE": "टिकट पुनः खोलना",
  "GRM_REOPEN.CONFIRM_QUESTION": "क्या आप वाकई टिकट दोबारा खोलना चाहते हैं?",
  "GRM_REOPEN.CONFIRM_ID": "आईडी : {{ticketId}}",
  "GRM_REOPEN.CANCEL": "नहीं, रद्द करें",
  "GRM_REOPEN.CONTINUE": "आगे बढ़ें",
  "GRM_REOPEN.SECTION": "टिकट पुनः खोलना",
  "GRM_REOPEN.PROCEED_WITH_OTP": "ओटीपी के साथ आगे बढ़ें",
  "GRM_REOPEN.VERIFY_SUBMIT": "सत्यापित करें और जमा करें",
  "GRM_REOPEN.SUBMIT_ERROR": "टिकट पुनः नहीं खोला जा सका। कृपया पुनः प्रयास करें।",
  "GRM_REOPEN.SUCCESS_TITLE": "शिकायत सफलतापूर्वक पुनः खोली गई",
  // inferred, needs translator
  "GRM_REOPEN.SUCCESS_BODY": "टिकट सफलतापूर्वक पुनः खोला गया और लंबित टिकट में भेज दिया गया है",
  // inferred, needs translator
  "GRM_REOPEN.SUCCESS_ID": "आईडी: {{id}}",
  // inferred, needs translator
  "GRM_REOPEN.REOPENED_ON": "पुनः खोलने की तिथि : {{date}}",
  "GRM_REOPEN.VIEW_TICKET": "टिकट देखें",
  "GRM_REOPEN.OKAY": "ठीक है",
};
